import React, { lazy } from "react";
import { getSettings } from "../common/settingsProvider";
import { getExternalToken, getJwtToken } from "../common/api/apiShared";
const QuestionnaireService = lazy(() =>
    import("@module-federation/enhanced/runtime").then(({ loadRemote }) =>
        loadRemote<{ default: React.ComponentType<any> }>("questionnaireService/App").then((mod) => mod!)
    )
);

export interface QuestionnaireProps {}

function MicroFrontend(props: QuestionnaireProps) {
    return (
        <main style={{ height: "100%" }}>
            <QuestionnaireService
                jwtToken={getJwtToken()}
                parentHost={getSettings().mainSiteBaseUrl}
                purchasePlansHost={getSettings().customerAdminWeb}
                externalToken={getExternalToken()}
            />
        </main>
    );
}

export default MicroFrontend;
